/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Guide_Stat_Award_ValueInputs */

const en_fw_guide_stat_award_value = /** @type {(inputs: Fw_Guide_Stat_Award_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. 1`)
};

const zh_fw_guide_stat_award_value = /** @type {(inputs: Fw_Guide_Stat_Award_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`第 1 名`)
};

/**
* | output |
* | --- |
* | "No. 1" |
*
* @param {Fw_Guide_Stat_Award_ValueInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_guide_stat_award_value = /** @type {((inputs?: Fw_Guide_Stat_Award_ValueInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Guide_Stat_Award_ValueInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_guide_stat_award_value(inputs)
	return zh_fw_guide_stat_award_value(inputs)
});
export { fw_guide_stat_award_value as "fw.guide.stat.award_value" }